import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";

const REQUEST_PAYMENT_TYPE_LABEL = "запрос";

import FormikTextField from "components/InputsField/formikInputs/FormikTextField";
import AsyncSelect from "components/InputsField/formikInputs/AsyncSelect";
import CheckboxGroup from "components/InputsField/formikInputs/CheckboxGroup";
import FormikCheckboxField from "components/InputsField/formikInputs/FormikCheckboxField";
import { PaymentDropdowns } from "service/dropdownServices/PaymentDropdowns";
import { onlyNumberInput, percentsInput, numberInput } from "components/InputsField/inputFormats";
import { ERROR_PLACE } from "components/InputsField/InputError";
import Title from "components/common/Layout/Title";
import FormRow, { ALIGN } from "components/common/Layout/FormRow";
import InputNote from "components/InputsField/InputNote";
import { getInputMask } from "helpers/currency";
import { UTILS } from "endpointsConst";
import styles from "./styles.module.scss";

export default function CargoPayment() {
    const { values, initialValues, setFieldValue } = useFormikContext();
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);
    const { t } = useTranslation();
    const lang = useSelector((state) => state.settings.lang);

    const getRateTranslate = (str) => t("cargoFields.rate_section." + str);
    const getPaymentTranslate = (str) => t("cargoFields.payment_section." + str);

    const isRequestType = useMemo(() => {
        if (!values.payment_type_id || !paymentTypeOptions.length) return false;
        const selectedOption = paymentTypeOptions.find(opt => opt.value === values.payment_type_id);
        return selectedOption?.label?.toLowerCase() === REQUEST_PAYMENT_TYPE_LABEL;
    }, [values.payment_type_id, paymentTypeOptions]);

    useEffect(() => {
        if (isRequestType && values.price !== "0" && values.price !== 0) {
            setFieldValue("price", "0");
        }
    }, [isRequestType, setFieldValue, values.price]);

    useEffect(() => {
        PaymentDropdowns.getPaymentTypes(lang)
            .then((res) => {
                const options = res.data.map((el) => ({
                    label: el.value,
                    value: el.id,
                }));
                setPaymentTypeOptions(options);
            })
            .catch((e) => {
                console.log(e.response);
            });
    }, [lang]);

    useEffect(() => {
        PaymentDropdowns.getCurrencies(lang)
            .then((res) => {
                let currencyOptions = res.data.map((el) => {
                    return {
                        label: el.value,
                        value: el.id,
                    };
                });
                setCurrencyOptions(currencyOptions);
            })
            .catch((e) => {
                console.log(e.response);
            });
    }, [lang]);

    return (
        <>
            <Title withMargin>{getRateTranslate("heading")}</Title>
            <FormRow align={ALIGN.top}>
                <div>
                    <AsyncSelect
                        url={`${UTILS}/paymentTypes/?lang=${lang}`}
                        label={getRateTranslate("type_rate")}
                        name="payment_type_id"
                        isClearable={true}
                    />
                    <div className={styles.wrapperNote}>
                        <InputNote note={getRateTranslate("type_rate_note")} />
                    </div>
                </div>
                <AsyncSelect
                    url={`${UTILS}/paymentRateTypes/?lang=${lang}`}
                    label={getRateTranslate("type_payment")}
                    name="payment_rate_type_id"
                    isClearable={true}
                    className={styles["payment__type"]}
                />
            </FormRow>
            <FormRow withMargin>
                <FormRow withSpace>
                    <FormikTextField
                        name="price"
                        label={getRateTranslate("rate")}
                        required={!isRequestType}
                        maxLength={13}
                        placeholder="0"
                        format={numberInput}
                        errorMode={ERROR_PLACE.topRight}
                        mask={getInputMask}
                        disabled={isRequestType}
                    />
                    <AsyncSelect
                        options={currencyOptions}
                        name="currency_id"
                        label={getRateTranslate("currency")}
                        required
                        placeholder={initialValues.prefix || ""}
                        errorMode={ERROR_PLACE.topRight}
                    />
                </FormRow>
                <div className={styles.ndsCheckbox}>
                    <FormikCheckboxField
                        name="is_vat_included"
                        id="is_vat_included"
                        label={getRateTranslate("vat_included")}
                    />
                </div>
            </FormRow>
            <Title withMargin>{getPaymentTranslate("heading")}</Title>
            <FormRow>
                <div className={styles.checkboxWrapper}>
                    <FormikTextField
                        label={getPaymentTranslate("prepayment")}
                        name="prepayment"
                        placeholder="0"
                        postfix="%"
                        format={percentsInput}
                    />
                    <div className={styles.checkbox}>
                        <CheckboxGroup
                            checkboxes={[
                                <FormikCheckboxField
                                    name="fuel_prepayment"
                                    id="fuel_prepayment"
                                    label={getPaymentTranslate("fuel_box")}
                                />,
                                <FormikCheckboxField
                                    name="upload"
                                    id="upload"
                                    label={getPaymentTranslate("unloading_box")}
                                />,
                            ]}
                        />
                    </div>
                </div>
            </FormRow>
            <FormRow withMargin>
                <div>
                    <FormikCheckboxField
                        name="direct_contract"
                        id="direct_contract"
                        label={getPaymentTranslate("contract_box")}
                    />
                    <div className={styles.wrapperNote}>
                        <InputNote note={getPaymentTranslate("contract_note")} />
                    </div>
                </div>
            </FormRow>
            <FormRow withMargin>
                <FormikTextField
                    name="bank_days"
                    maxLength={2}
                    placeholder={getPaymentTranslate("in_grey_text")}
                    format={onlyNumberInput}
                    label={getPaymentTranslate("in_box")}
                />
                <></>
            </FormRow>
        </>
    );
}
